<template>

    <div class="container-fluid">

        <div class="login-page">

            <div class="login-container">

                <div class="w-100">
                    <a href="/"><img src="/images/card/logo.svg" class="logo"></a>
                </div>

                <div class="w-100">

                    <div v-if="mode === 'reset'">
                        <h1 class="mb-6">Återställ ditt lösenord</h1>
                    </div>

                    <div v-if="mode === 'activate'">
                        <h1 class="mb-2">Aktivera ditt konto</h1>
                        <p class="mb-8">Aktivera ditt konto genom att välja ett lösenord nedan och spara. Välkommen!</p>
                    </div>

                    <div class="alert alert-success" v-if="success">
                        Ditt lösenord har sparats. Öppna appen och logga in på nytt.
                    </div>

                    <form @submit.prevent="posterPost">
                        <input-text
                            type="password"
                            name="password"
                            label="Välj lösenord"
                            form-group-class="mb-4"
                            v-model="password"
                            :float-label="true"
                        />

                        <input-text
                            type="password"
                            name="password_confirmation"
                            label="Upprepa lösenord"
                            form-group-class="mb-4"
                            v-model="password_confirmation"
                            :float-label="true"
                        />

                        <div class="alert alert-danger" v-if="former.errors.email || former.errors.token">
                            <span v-if="former.errors.email">{{ former.errors.email[0] }}</span>
                            <span v-if="former.errors.token">{{ former.errors.token[0] }}</span>
                        </div>

                        <button class="btn btn-primary float-end" :disabled="poster.submitted">
                            <span class="spinner-border spinner-border-sm"></span>
                            <span v-if="mode === 'activate'">Aktivera konto</span>
                            <span v-else>Spara</span>
                        </button>

                    </form>
                </div>

                <div class="forgot-link-container"></div>

            </div>

        </div>

    </div>

</template>

<script>

import poster from '../../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    data () {
        return {
            password: '',
            password_confirmation: '',
            mode: this.$route.meta.mode,
            success: false
        }
    },

    computed: {
        posterUrl () {
            return '/password/reset'
        },
        posterData () {
            return {
                password: this.password,
                password_confirmation: this.password_confirmation,
                phone: this.$route.query.phone,
                token: this.$route.query.token
            }
        }
    },

    methods: {
        posterSuccess () {
            if (this.mode === 'activate') {
                window.location.href = '/login?activated=1'
                return
            }

            this.success = true
        }
    }

}

</script>
